// src/components/tour/ProfilesTourSteps.tsx
import { Step } from 'react-joyride';

const ProfilesTourSteps: Step[] = [
  {
    target: 'h1',
    content: (
      <div style={{ textAlign: 'justify' }}>
        Bienvenido a la sección de <strong>Perfiles</strong>. Aquí puedes elegir
        con qué rol deseas acceder a la plataforma: empresa, trabajador, cliente
        o administrador.
      </div>
    ),
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    target: '.tour-help',
    content: (
      <div style={{ textAlign: 'justify' }}>
        Si necesitas una guía interactiva en cualquier momento, haz clic en este
        botón de <strong>Ayuda</strong> para volver a ver el recorrido.
      </div>
    ),
    placement: 'left',
    disableBeacon: true,
  },
  {
    target: '.tour-profile-card:first-child',
    content: (
      <div style={{ textAlign: 'justify' }}>
        Cada tarjeta representa uno de tus <strong>perfiles disponibles</strong>
        . Desde aquí puedes acceder al panel correspondiente a ese rol.
      </div>
    ),
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    target: '.tour-switch',
    content: (
      <div style={{ textAlign: 'justify' }}>
        Usa este interruptor para definir qué perfil se abrirá de forma
        <strong>automática</strong> la próxima vez que inicies sesión.
      </div>
    ),
    placement: 'left',
    disableBeacon: true,
  },
  {
    target: '.tour-login-btn',
    content: (
      <div style={{ textAlign: 'justify' }}>
        Pulsa este botón para <strong>acceder al panel</strong> de ese perfil y
        comenzar a trabajar o gestionar tu cuenta.
      </div>
    ),
    placement: 'top',
    disableBeacon: true,
  },
  {
    target: 'header',
    content: (
      <div style={{ textAlign: 'justify' }}>
        Desde la parte superior puedes cerrar tu sesión de forma segura en
        cualquier momento con el botón rojo <strong>"Cerrar sesión"</strong>.
      </div>
    ),
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    target: 'footer',
    content: (
      <div style={{ textAlign: 'justify' }}>
        Aquí verás información general de Bookoll y el año actual. Este pie de
        página estará presente en la mayoría de las secciones.
      </div>
    ),
    placement: 'top',
    disableBeacon: true,
  },
];

export default ProfilesTourSteps;
